import React, { useCallback, useEffect, useState } from "react";
import { MasterTable } from "../../components/_index";
import { Box } from "@mui/material";
import AddClientManagement from "../ClientManagement/AddClientManagement";
import { getMainUser } from "../../services/user.service";
import { debounce } from "../../utils/debounce";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";

const UserManagement = () => {
  const [data, setData] = useState([]);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [selectedData, setSelectedData] = useState({});
  const [tableTotalCount, setTableCount] = useState(0);
  const [openLoader, setOpenLoader] = useState(false);
  const [queryParam, setQueryParam] = useState({
    search: "",
    page: 1,
    limit: 10,
    sortType: "",
    sort: "",
  });

  const GetUserData = async () => {
    setOpenLoader(true);
    try {
      const res = await getMainUser(queryParam);
      console.log("res", res);
      const modifiedData =
        res?.data.data.map((e) => ({
          ...e,
          roleName:e?.roleData?.name
        })) || [];
      setTableCount(res?.data?.totalCount || 0);
      setData(modifiedData);
      setOpenLoader(false);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    GetUserData();
  }, [queryParam.search, queryParam.limit, queryParam.sort, queryParam.page]);

  const columns = [
    { id: "name", label: "Name" },
    { id: "project_role_string", label: "Project RoleName", split:"  " },
    { id: "email", label: "E-mail" },
  ];

  const tableOutputEvent = useCallback((params) => {
    setQueryParam((queryParams) => ({
      ...queryParams,
      ...params,
    }));
  }, []);

  const handleCloseDrawer = () => {
    setOpenDrawer(false);
  };

  const handleEdit = (e) => {
    setOpenDrawer(true);
    setSelectedData(e);
  };

  const debouncedHandleSearch = useCallback(
    debounce((searchText) => {
      setQueryParam((queryParams) => ({
        ...queryParams,
        search: searchText,
      }));
    }, 300),
    []
  );

  const handleSearch = (searchText) => {
    debouncedHandleSearch(searchText);
  };

  return (
    <div className="mainContent">
      <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
        <Box className="SearchInputBoxContainer">
          <SearchOutlinedIcon className="Search_Icon" />
          <input
            className="SearchInputBox"
            placeholder="Search here"
            onChange={(e) => handleSearch(e.target.value)}
          />
        </Box>
      </Box>
      <MasterTable
        data={data}
        columns={columns}
        isServerSide={true}
        tableTotalCount={tableTotalCount}
        tableOutputEvent={tableOutputEvent}
        openLoader={openLoader}
      />
      {openDrawer ? (
        <AddClientManagement
          open={openDrawer}
          setOpenDrawer={setOpenDrawer}
          selectedData={selectedData}
          handleCloseDrawer={handleCloseDrawer}
          formType={selectedData._id ? "edit" : "add"}
          GetUserData={GetUserData}
        />
      ) : null}
    </div>
  );
};

export default UserManagement;
